import Vue from "vue";
import Vuex from "vuex";
import { ACCOUNT_TYPE } from "@/constants";
import * as getters from "./getters";
import * as actions from "./actions";
import * as mutations from "./mutations";

Vue.use(Vuex);

const state = {
  // 账号信息
  accountInfo: { login: "", accountType: -1 },
  // 供应商信息
  supplierInfo: {},
  // 菜单列表
  supplierMenuList: [],
  merchantState: {
    state: -1,
  },
  // 默认为供应商
  accountTypeByPath: ACCOUNT_TYPE.SUPPLIER,
};

const store = new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
});

export default store;
